
export const SIZES = {
	SMALL: 'sm',
	MEDIUM: 'md',
	LARGE: 'lg',
};